import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	stepsContainer: {
		padding: '0px 16px !important',
		'& .MuiStepIcon-completed': {
			color: theme.palette.secondary.main,
		},
		'& .MuiStepper-root': {
			padding: '0px 16px !important',
		},
	},
	activeSection: {
		color: theme.palette.secondary.main + '!important',
		cursor: 'pointer',
	},
	videoContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 'fit-content',
		'& hr': {
			margin: '16px 0px',
			width: '100%',
		},
		'& h2': {
			margin: '8px 0px',
		},
		[theme.breakpoints.down('md')]: {
			order: 0,
			'& h2': {
				fontSize: 20,
			},
			'& h5': {
				fontSize: 14,
			},
		},
	},
	video: {
		[theme.breakpoints.down('md')]: {
			display: 'flex',
			justifyContent: 'center',
		},
	},
	buttonContainer: {
		paddingTop: 24,
		width: '100%',
		flexDirection: 'column',
		display: 'flex',
		alignItems: 'flex-end',
		justifyContent: 'center',
		paddingBottom: 36,
	},
	sectionContainer: {
		[theme.breakpoints.down('md')]: {
			order: 1,
		},
	},
	divider: {
		width: '100%',
		height: 2,
		marginBottom: 16,
	},
	successText: {
		color: theme.palette.success.dark,
	},
	errorText: {
		color: theme.palette.error.main,
	},
	dialogActions: {
		display: 'flex',
		width: '100%',
		justifyContent: 'space-between',
	},
}));

export default useStyles;
